import React from 'react';
import { Typography, Tooltip } from '@material-ui/core';

export default function DateOutLookup(data) {
  return <p className="date-out">{data.value}</p>;
}
